module.exports = __webpack_public_path__ + "img/zx2.e1404b4d.png";